// @flow

import { stripNonMatching } from '@tectonics/utils/formatting';

const ENDS_WITH_K_REGEXP = /k$/ui;

export function normalizeDocument(documentValue: ?string): string {
  const numbers = documentValue ? stripNonMatching(documentValue, 'numeric') : '';
  const k = documentValue && ENDS_WITH_K_REGEXP.test(documentValue) ? 'K' : '';
  return numbers + k;
}
